<template>
  <section :key="'userInfo_multisection'">
    <div class="mypooq-top-wrap">
      <div class="mypooq-top">
        <div class="wrap">
          <ul class="my-list">
            <li>
              <button class="btn-alarm" @click="clickAlarm()">
                <span class="my-list-label">알림</span>
                <span class="my-list-point">{{ alarmCount }}</span>
              </button>
            </li>
            <li>
              <router-link
                class="btn-ticket"
                :to="{ name: PATH_NAME_SUBSCRIPTION_TICKET }"
              >
                <span class="my-list-label">이용권</span>
                <span class="my-list-point">{{ ticketCount }}</span>
              </router-link>
            </li>
            <li>
              <router-link class="btn-coin" :to="{ name: PATH_NAME_COIN }">
                <span class="my-list-label">코인</span>
                <span class="my-list-point">{{
                  coinCount | setNumberCommas
                }}</span>
              </router-link>
            </li>
            <li>
              <router-link class="btn-coupon" :to="{ name: PATH_NAME_COUPON }">
                <span class="my-list-label">쿠폰</span>
                <span class="my-list-point">{{
                  couponCount | setNumberCommas
                }}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="my-ticket-info">
        <div class="wrap">
          <div
            :class="['my-ticket-info-l', hasTicket ? 'has-ticket-profile' : '']"
          >
            <div class="profile-image-wrap">
              <img
                :src="getImage(profileImage)"
                :alt="profileName + '님 프로필'"
              />
            </div>
            <div class="profile-text-wrap">
              <span class="profile-inner-wrap">
                <span class="profile-name">{{ profileName }}</span>
                <span class="profile-title">&nbsp;님</span>
                <div v-if="showTooltip" class="my-tooltip">
                  <span>새로워진 프로필 이미지를 확인해보세요.</span>
                </div>
              </span>
              <template v-if="summary !== null">
                <!-- 진행중인 프로모션이 있을 때 -->
                <template v-if="hasPromotion">
                  <div class="profile-link">
                    <div class="promotion-text">
                      <span :style="`color:${promotionColor1}`">{{
                        promotionText1 + ' '
                      }}</span>
                      <span :style="`color:${promotionColor2}`">{{
                        promotionText2
                      }}</span>
                    </div>
                    <a
                      v-if="buttonUrl !== ''"
                      href="#"
                      @click.prevent="goButtonUrl(buttonUrl)"
                      >{{ buttonText }}</a
                    >
                  </div>
                </template>
                <!-- 진행중인 프로모션 없고, 보유중인 이용권 없을 때 -->
                <template v-else-if="!hasTicket">
                  <div class="profile-link">
                    <div class="promotion-text">
                      <span>현재 보유하신 이용권이 없습니다</span>
                    </div>
                    <a
                      href="#"
                      @click.prevent="
                        goButtonUrl('www.wavve.com/voucher/index')
                      "
                      >구매하기</a
                    >
                  </div>
                </template>
              </template>
            </div>
          </div>
          <div class="my-ticket-info-r">
            <div class="profile-metadata-wrap">
              <div class="profile-metadata">
                <!-- 이용권 가지고 있을때 -->
                <template v-if="hasTicket">
                  <ul class="profile-metadata-list ticket">
                    <li>
                      <span>이용 중 이용권</span>
                      <router-link
                        class="value"
                        :to="{ name: PATH_NAME_SUBSCRIPTION_TICKET }"
                      >
                        <span v-html="ticketDescription"></span>
                      </router-link>
                    </li>
                  </ul>
                </template>
                <ul class="profile-metadata-list">
                  <li>
                    <router-link
                      :to="{ name: PATH_NAME_VOUCHER_LIST_SINGULAR }"
                    >
                      <span>구매 콘텐츠</span>
                      <span class="value">&nbsp;{{ purchaseCount }}</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: PATH_NAME_DEVICE_HISTORY }">
                      <span>디바이스 관리</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { getMySummary, getAlarmsNew } from '@/common/utils/request'
  import {
    PATH_NAME_SUBSCRIPTION_TICKET,
    PATH_NAME_COIN,
    PATH_NAME_COUPON,
    PATH_NAME_VOUCHER_INDEX,
    PATH_NAME_VOUCHER_LIST_SINGULAR,
    PATH_NAME_DEVICE_HISTORY,
  } from '@/common/resources/router.const'
  import cookie from '@/common/utils/cookie'
  import _ from 'lodash'
  import { setNumberCommas } from '@/common/utils/common'
  import { url } from '@/common/filters/url.filter'
  import constant from '@/common/resources/constant'
  import {
    ALARM_POPUP_TYPE_ALL,
    SHOW_ALARM_POPUP,
  } from '@/common/resources/const'
  import { resizeThumbnail } from '@/common/utils/image'
  export default {
    filters: {
      setNumberCommas,
      url,
    },
    data() {
      return {
        PATH_NAME_SUBSCRIPTION_TICKET,
        PATH_NAME_COIN,
        PATH_NAME_COUPON,
        PATH_NAME_VOUCHER_INDEX,
        PATH_NAME_VOUCHER_LIST_SINGULAR,
        PATH_NAME_DEVICE_HISTORY,
        summary: null,
        alarmInfo: null,
        showTooltip: cookie.getItem('profile-tooltip') !== '1',
      }
    },
    computed: {
      hasTicket() {
        return _.get(this.summary, 'mypass', []).length > 0
      },
      alarmCount() {
        return this.convert3DigitCount(_.get(this.alarmInfo, 'count', '0'))
      },
      ticketCount() {
        return _.get(this.summary, 'mypass', []).length
      },
      coinCount() {
        return Number(_.get(this.summary, 'coin', '0'))
      },
      couponCount() {
        return Number(_.get(this.summary, 'coupon', '0'))
      },
      ticketDescription() {
        return (
          _.get(this.summary, ['mypass', 0, 'producttext'], '') +
          ' ' +
          _.get(this.summary, ['mypass', 0, 'attributetext'], '').replace(
            /\$O\$/gi,
            '<span class="icon-dotted"></span>',
          )
        )
      },
      purchaseCount() {
        return this.convert3DigitCount(
          _.get(this.summary, 'purchasecount', '0'),
        )
      },
      profileImage() {
        return (
          cookie.userInfo('profileimage') ||
          'img.wavve.com/service30/profile/0.png'
        )
      },
      profileName() {
        return cookie.userInfo('profilename') || '회원님'
      },
      hasPromotion() {
        return _.get(this.summary, 'promotion', []).length > 0
      },
      promotionText1() {
        return _.get(this.summary, 'promotion.0.text1', '')
      },
      promotionText2() {
        return _.get(this.summary, 'promotion.0.text2', '')
      },
      promotionColor1() {
        return _.get(this.summary, 'promotion.0.text1color', '')
      },
      promotionColor2() {
        return _.get(this.summary, 'promotion.0.text2color', '')
      },
      buttonText() {
        return _.get(this.summary, 'promotion.0.button', '')
      },
      buttonUrl() {
        return _.get(this.summary, 'promotion.0.link', '')
      },
    },
    created() {
      this.init()
    },
    mounted() {
      if (this.showTooltip) {
        document.body.addEventListener('click', this.hideToolTip)
      }
    },
    methods: {
      getImage(img) {
        return resizeThumbnail(img, {
          width: 0,
          height: 0,
          option: 20,
          quality: 80,
        })
      },
      clickAlarm() {
        this.$events.$emit(SHOW_ALARM_POPUP, ALARM_POPUP_TYPE_ALL)
      },
      goButtonUrl(url) {
        const buttonUrl = url.replace('http://', '').replace('https://', '')
        location.href = `${location.protocol}//${buttonUrl}`
      },
      setAlarmNew() {
        getAlarmsNew().then(({ data }) => {
          this.alarmInfo = data
        })
      },
      setSummaryData() {
        getMySummary().then(({ data }) => {
          this.summary = data
        })
      },
      setData() {
        this.setSummaryData()
        this.setAlarmNew()
      },
      hideToolTip() {
        const expires = new Date()
        expires.setFullYear(expires.getFullYear() + 1)
        cookie.setItem(
          'profile-tooltip',
          '1',
          expires.toUTCString(),
          constant.URL_COOKIE_DOMAIN,
          '/',
        )
        this.showTooltip = false
        document.body.removeEventListener('click', this.hideToolTip)
      },
      init() {
        this.setData()
      },
      convert3DigitCount(count) {
        return Number(count) > 99 ? '99+' : count
      },
    },
  }
</script>
